import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"

import { COLORS, TYPE } from "../../../theme/styles/globals"
import { MODE, ALIGN } from "../globals"
import Blocks from "../blocks/blocks"

import PatternDarkPNG from "../../../theme/img/pattern-dark.png"
import PatternLightPNG from "../../../theme/img/pattern-light.png"

export default class ContentfulModuleProjectSection extends React.Component {

  containerRef = React.createRef()
  
  renderBlock(__typename, props, mode, transition) {
    return (ContentfulBlock => (
      <ContentfulBlock {...props} mode={mode} transition={transition} />
    ))(Blocks[__typename])
  }

  componentDidMount(){
    const spy = new IntersectionObserver(this.onInView, {

    })
    spy.observe(this.containerRef.current)
  }

  onInView = (items) => {
    const { mode } = this.props
    if(items[0].isIntersecting && items[0].intersectionRatio > 0){
      // console.log(`-----------------`)
      // console.log(mode)
      // console.log(items[0])
    }
  }

  render() {

    const {
      mode,
      blendLeft,
      blendRight,
      backgroundText,
      backgroundTextPosition,
      blocks,
      transition,
    } = this.props

    return (
      <Container 
        mode={mode} 
        blendLeft={blendLeft} 
        blendRight={blendRight}
        ref={this.containerRef}
      >
        {blocks.map((block, i) => {
          return (
            <BlockWrap key={i}>
              {this.renderBlock(block.__typename, block, mode, transition)}
            </BlockWrap>
          )
        })}
        {/* <Pattern mode={mode} />  */}
        {backgroundText && (
          <Background mode={mode} position={backgroundTextPosition}>
            {backgroundText}
          </Background>
        )}
      </Container>
    )

  }

}

const Container = styled.section`
  width: 100%;
  height: auto;
  background-color: ${props => props.mode === MODE.LIGHT ? `${COLORS.WHITE}` : `${COLORS.DARK_GREY_1}`};
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-top: 50px;
  /* padding-bottom: 20px; */

  ${up("md")} {
    padding-top: 0px;
    padding-bottom: 0px;
    flex-direction: row;
    width: auto;
    height: 100vh;
    ${props =>
      props.blendLeft === true ? `padding-left:75px;` : `padding-left:150px;`}
    ${props =>
      props.blendRight === true
        ? `padding-right:75px;`
        : `padding-right:150px;`}

    &:before {
      ${up("md")} {
        ${props =>
          props.blendLeft === true
            ? `
          content: " ";
          width:240px;
          height:100vh;
          background-color:${
            props.mode === MODE.LIGHT
              ? `${COLORS.DARK_GREY_1}`
              : `${COLORS.WHITE}`
          };
          position:absolute;
          top:0px;
          left:0px;
          z-index:0;
        `
            : ``}
      }
    }

    &:after {
      ${up("md")} {
        ${props =>
          props.blendRight === true
            ? `
          content: " ";
          width:240px;
          height:100vh;
          background-color:${
            props.mode === MODE.LIGHT
              ? `${COLORS.DARK_GREY_1}`
              : `${COLORS.WHITE}`
          };
          position:absolute;
          top:0px;
          right:0px;
          z-index:0;
        `
            : ``}
      }
    }
  }
`

const Background = styled.div`
  display:none;

  ${up("md")}{
    position:absolute;
    display:block;
    z-index:1;
    font-family:${TYPE.SERIF_BOLD_FONT};
    font-size:200px;
    ${props =>
      props.mode === MODE.LIGHT
        ? `color:${COLORS.LIGHT_GREY_1}; opacity:.5;`
        : `color:${COLORS.DARK_GREY_2}; opacity:.25;`};
    ${props => (props.position === ALIGN.TOP_LEFT ? `top:-40px; left:-10px;` : ``)}
    ${props => props.position === ALIGN.TOP_RIGHT ? `top:-40px; right:0px;` : ``}
    ${props => props.position === ALIGN.BOTTOM_LEFT ? `bottom:-60px; left:0px;` : ``}
    ${props => props.position === ALIGN.BOTTOM_RIGHT ? `bottom:-60px; right:0px;` : ``}
  }

  ${up('xl')} {
    font-size:260px;
    ${props => (props.position === ALIGN.TOP_LEFT ? `top:-50px; left:-10px;` : ``)}
    ${props => props.position === ALIGN.TOP_RIGHT ? `top:-50px; right:0px;` : ``}
    ${props => props.position === ALIGN.BOTTOM_LEFT ? `bottom:-70px; left:0px;` : ``}
    ${props => props.position === ALIGN.BOTTOM_RIGHT ? `bottom:-70px; right:0px;` : ``}
  }
`

const Pattern = styled.div`
  display: none;

  ${up("md")} {
    position: absolute;
    display: block;
    z-index: 2;

    ${props =>
      props.mode === MODE.LIGHT
        ? `
      background-image:url(${PatternDarkPNG});
    `
        : `
      background-image:url(${PatternLightPNG});
      opacity:.5;
    `}

    background-size: 24px 24px;
    background-repeat: repeat;
    width: 20%;
    height: 500px;
    top: 50%;
    left: 30px;
    margin-top: -250px;
  }
`

const BlockWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  z-index: 4;
`
// const InView = styled(Observer)`
//   width: 100%;
//   height: 100%;
//   position: relative;
//   display:flex;
// `